module.exports = __webpack_public_path__ + "ui-icons_ef8c08_256x240.png";


//////////////////
// WEBPACK FOOTER
// ./~/jquery-ui-bundle/images/ui-icons_ef8c08_256x240.png
// module id = 120
// module chunks = 0